import { useBreakpoint } from '@ocean/hooks'
import { layouts } from '@ocean/ui'
import { LayoutProps, ListSectionLayoutSegmentProps } from 'layouts/types'
import withLayout from 'layouts/withLayout'
import { Root, Header, Footer } from './ListSectionLayout.styled'

const { SectionLayout } = layouts

export type ListSectionLayoutSegments = 'header' | 'content' | 'footer'
type InternalLayoutProps = LayoutProps<ListSectionLayoutSegments>

export const ListSectionSegment: React.FC<ListSectionLayoutSegmentProps> = ({ children }) => (
  <>{children}</>
)

const ListSectionLayout = ({ segments }: InternalLayoutProps) => {
  const isDesktop = useBreakpoint('sm')

  function renderContent() {
    const content = <>{segments?.content}</>

    if (!isDesktop) return content

    return <SectionLayout>{content}</SectionLayout>
  }

  return (
    <Root>
      {segments?.header && (
        <Header>
          <SectionLayout>{segments.header}</SectionLayout>
        </Header>
      )}
      {renderContent()}
      {segments?.footer && (
        <Footer>
          <SectionLayout>{segments.footer}</SectionLayout>
        </Footer>
      )}
    </Root>
  )
}

export default withLayout(ListSectionLayout)
